import { SCREEN_FILTER_CODE } from "constants/DashboardContanst";
import { AUTH_STATUS_REJECT } from "constants/FormatDataContanst";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import ListInvoicePos from "./ListInvoicePos";

const ListTaxRefusedApprovalInvoicePos = () => {
  const [filterList, setFilterList] = useState({
    "filter[auth_status][in]": [AUTH_STATUS_REJECT],
  });

  const Dashboard = useSelector(state => state.Dashboard);
  const { finalBuInfo } = Dashboard;

  // Action list chang tenantCode
  useEffect(() => {
    if (finalBuInfo) {
      setFilterList({
        ...filterList,
        "filter[invoice_type]": finalBuInfo?.invoice_type,
      });
    }
  }, [finalBuInfo]);

  return (
    <React.Fragment>
      <ListInvoicePos
        filterList={filterList}
        screenFilterCode={SCREEN_FILTER_CODE.INVOICE_CANCEL}
        listStatusFilter={[AUTH_STATUS_REJECT]}
        title={"DANH SÁCH HÓA ĐƠN TỪ MTT THUỂ TỪ CHỐI DUYỆT"}
        titleManger={"HÓA ĐƠN"}
      />
    </React.Fragment>
  );
};

export default ListTaxRefusedApprovalInvoicePos;
